export default __webpack_public_path__ + "static/media/logo_with_text.679a6cb6.png";